import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const RequireAdminAuth = () => {
    const { user } = useAuth();
    const location = useLocation();
    return (
        user?.attributes.type === 'admin' 
        ? <Outlet/>
        : <Navigate to="/dashboard" state={{ from: location }} replace />
    )
}

export default RequireAdminAuth;